import * as React from 'react'
export function Bars({ title = 'Bars', className, ...props }) {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="https://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <title>{title}</title>
      <path
        d="M32.4183 47.9874V25.1429C32.4183 23.7032 33.5927 22.5288 35.0324 22.5288H38.8208C40.2605 22.5288 41.4349 23.7032 41.4349 25.1429V47.9874H32.4183Z"
        fill="url(#paint0_radial_2497_55945)"
      />
      <path
        d="M15.0039 48H6V2.61405C6 1.17443 7.17443 0 8.61405 0H12.4025C13.8295 0 15.0039 1.17443 15.0039 2.61405V48Z"
        fill="url(#paint1_radial_2497_55945)"
      />
      <path
        d="M19.2092 48V13.7395C19.2092 12.2999 20.3836 11.1255 21.8232 11.1255H25.6117C27.0513 11.1255 28.2257 12.2999 28.2257 13.7395V48H19.2092Z"
        fill="url(#paint2_radial_2497_55945)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_2497_55945"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(42.8741 50.9393) scale(112.21 53.295)"
        >
          <stop stopColor="#3B6AF2" />
          <stop offset="1" stopColor="#19ACDD" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_2497_55945"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(42.8761 50.8713) scale(197.849 49.7704)"
        >
          <stop stopColor="#3B6AF2" />
          <stop offset="1" stopColor="#19ACDD" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_2497_55945"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(18.8554 8.90558) rotate(180) scale(41.3449 40.9315)"
        >
          <stop stopColor="#3B6AF2" />
          <stop offset="1" stopColor="#19ACDD" />
        </radialGradient>
      </defs>
    </svg>
  )
}
export default Bars
